export const RESULTS_PER_PAGE = 100;
/** Number of pages in both directions to preload when an uncached page is loaded. */
export const SURROUNDING_PAGES_TO_CACHE = 5;
/** Number of results to request from API for initial data load on loading saved query or new search.
 * LazyPaginationController controls subsequent load size.
 */
export const getInitialLoadSize = (surroundingPagesToCache: number) =>
  RESULTS_PER_PAGE * (surroundingPagesToCache + 1);

export const INITIAL_LOAD_SIZE = getInitialLoadSize(SURROUNDING_PAGES_TO_CACHE);

export const NO_SURROUNDING_PAGES_TO_CACHE = 0;
